module.exports = "<fuse-navigation layout=\"horizontal\"></fuse-navigation>\n"


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module id = ../../../../../src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module chunks = main